import { motion } from "framer-motion";
import { Award, Map, TrendingUp } from "lucide-react";

const props = [
  {
    icon: Award,
    title: "Verified Digital Stamps",
    body:
      "Stamps are issued only after campsite operators verify your check-in via QR — every stamp is a real adventure.",
  },
  {
    icon: Map,
    title: "Discover More Campsites",
    body:
      "Explore new destinations across Malaysia, filter by state, and save your favorites for the next trip.",
  },
  {
    icon: TrendingUp,
    title: "Gamified Experience",
    body:
      "Level up your passport, unlock badges and achievements, and compete with your camping friends.",
  },
];

export default function ValueProps() {
  return (
    <section data-testid="value-props" className="py-20 md:py-28">
      <div className="wrap">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow mb-4">Why MyAdventure-Passport</div>
          <h2 className="section-title">
            Every campsite tells a story worth remembering.
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {props.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-elev"
              data-testid={`value-card-${i}`}
            >
              <div className="icon-tile">
                <p.icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-extrabold mb-2" style={{ color: "var(--on-surface)" }}>
                {p.title}
              </h3>
              <p className="body-lg">{p.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
